import api from "./api";

const productosPorCodigo = new Map();

export const buscarItemsPorCodigo = async (
  codigo,
  { page = 0, size = 20, signal } = {}
) => {
  const response = await api.get("/v1/items", {
    params: { codigo, page, size },
    signal,
  });
  return response.data;
};

export const buscarProductoPorId = async (codigo) => {
  const clave = String(codigo);
  if (!productosPorCodigo.has(clave)) {
    const consulta = api.get("/v1/items", {
      params: { codigo, page: 0, size: 1 },
    }).then((response) => response.data?.content?.[0] || null)
      .catch((error) => {
        productosPorCodigo.delete(clave);
        throw error;
      });

    productosPorCodigo.set(clave, consulta);
  }

  return productosPorCodigo.get(clave);
};

export const buscarItemsPorDescripcion = async (
  descripcion,
  { page = 0, size = 20, signal } = {}
) => {
  const response = await api.get("/v1/items", {
    params: { descripcion, page, size },
    signal,
  });
  return response.data;
};

export const listarPracticas = async ({ practica } = {}) => {
  const params = new URLSearchParams();

  params.append("text", practica);

  const response = await api.get(`/v1/practicas?${params.toString()}`);
  return response.data;
};

export const buscarPracticas = async (
  { codigo, descripcion, page = 0, size = 30, signal } = {}
) => {
  const response = await api.get("/v1/items", {
    params: { codigo, descripcion, page, size },
    signal,
  });
  return response.data;
};

/*
  Medicamentos viven en un catalogo aparte (nomenclador.medicamento, codigo
  reservado 98xxxxxx), no en /v1/items. Mismo endpoint que usa el buscador de
  la rama Medicacion del wizard de autorizaciones-web.
*/
export const buscarMedicamentos = async (
  { q, page = 0, size = 30, signal } = {}
) => {
  const response = await api.get("/v1/medicamentos", {
    params: { q, page, size },
    signal,
  });
  return response.data;
};

export const obtenerRequisitosPractica = async (codigo, { signal } = {}) => {
  const response = await api.get(`/v1/practicas/${encodeURIComponent(codigo)}/requisitos`, {
    signal,
  });
  return response.data;
};

/*
  Practicas que no estan en el nomenclador. El codigo sale de una secuencia del backend: el que
  devuelve esta llamada ya queda reservado para quien lo pidio, asi que es el que se manda al
  confirmar. Si el usuario cancela, ese numero queda sin usar.
*/
export const reservarCodigoFueraPmo = async () => {
  const response = await api.get("/v1/items/fuera-nomenclador/proximo-codigo");
  return response.data?.codigo || "";
};

export const crearPracticaFueraPmo = async (descripcion, codigo) => {
  const response = await api.post("/v1/items/fuera-nomenclador", { descripcion, codigo });
  return response.data;
};
